import { Link } from 'react-router-dom';
import { useScrollAnimation, getStaggerProps } from '@/hooks/useScrollAnimation';

export default function HeroSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.12 });

  return (
    <section ref={ref} className="relative min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          src="https://public.readdy.ai/ai/video_res/019fb1e8-4d41-7873-9dd1-07b29485d2cb.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/55 via-primary-800/35 to-primary-900/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-3xl ml-10 text-left">
          <span
            {...getStaggerProps(isVisible, 0, 0, 'fadeUp')}
            className="inline-block px-3 py-1.5 text-xs font-medium text-accent-300 border border-accent-400/30 rounded-full mb-6 whitespace-nowrap"
          >
            財經知識出版品牌
          </span>

          <h1
            {...getStaggerProps(isVisible, 1, 80, 'fadeUp')}
            className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight tracking-tight mb-4"
            style={{
              textShadow: '0 2px 12px rgba(0,0,0,0.5), 0 4px 24px rgba(0,0,0,0.35)',
            }}
          >
            財經錢線
          </h1>

          <h2
            {...getStaggerProps(isVisible, 2, 150, 'fadeUp')}
            className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50/90 leading-tight tracking-tight mb-6"
            style={{
              textShadow: '0 1px 8px rgba(0,0,0,0.45), 0 2px 16px rgba(0,0,0,0.3)',
            }}
          >
            從市場、人性與歷史，<br />看懂選擇背後的邏輯
          </h2>

          <p
            {...getStaggerProps(isVisible, 3, 220, 'fadeUp')}
            className="text-sm md:text-base text-background-50/80 leading-relaxed mb-4 max-w-2xl"
            style={{
              textShadow: '0 1px 6px rgba(0,0,0,0.4)',
            }}
          >
            財經錢線以商業理財為主要出版方向，並延伸投資心理學與以古諷今類內容，透過市場觀察、人性分析與歷史對照，協助讀者理解決策、風險與現實議題。
          </p>

          <p
            {...getStaggerProps(isVisible, 4, 280, 'fadeUp')}
            className="text-sm md:text-base text-accent-400/85 font-medium mb-10"
            style={{
              textShadow: '0 1px 4px rgba(0,0,0,0.35)',
            }}
          >
            財經錢線為崧博出版合作經銷品牌之一，網站提供正式出版書籍、書目資料與合作購書通路入口。
          </p>

          <div
            {...getStaggerProps(isVisible, 5, 340, 'fadeUp')}
            className="flex flex-col sm:flex-row items-center justify-start gap-3"
          >
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-accent-500 text-primary-950 rounded-full hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              認識財經錢線
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </span>
            </Link>
            <Link
              to="/stores"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-background-50/15 text-background-50 border border-background-50/25 rounded-full hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看合作購書通路
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}